import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Button } from 'antd';

import { getFormattedCurrency } from '../../forms/formHelpers';

const linkStyle = {
  padding: 0,
  border: 'none',
  height: 'auto',
  marginRight: 16,
  fontSize: 'inherit',
  lineHeight: 'inherit',
};

/** Displays the invoice details associated with a history entry */
function HistoryEntryDetails({
  invoiceNumber,
  templateName,
  vendor,
  amount,
  style = {},
  offset = 1,
  dailyBilling = 0,
  hourlyBilling = 0,
  onInvoiceClick,
  invoiceId,
  onFormClick,
  formId,
  isFormLoading = false,
}) {
  // One action row at the end, so the data lines above stay contiguous.
  const formLink = onFormClick && formId ? (
    <Button
      style={linkStyle}
      type="link"
      loading={isFormLoading}
      onClick={() => onFormClick(formId)}
    >
      View Form
    </Button>
  ) : null;
  const invoiceLink = onInvoiceClick && invoiceId ? (
    <Button style={linkStyle} type="link" onClick={() => onInvoiceClick(invoiceId)}>View Invoice</Button>
  ) : null;

  return (
    <Row style={style}>
      {invoiceNumber ? <Col span={24} offset={offset}>{`Inv# - ${invoiceNumber}`}</Col> : null}
      {vendor ? <Col span={24} offset={offset}>{`Vendor - ${vendor}`}</Col> : null}
      {templateName ? <Col span={24} offset={offset}>{`Form: ${templateName}`}</Col> : null}
      {typeof amount === 'number' && amount !== 0 ? <Col span={24} offset={offset}>{`Amount Allocated - ${getFormattedCurrency(amount)}`}</Col> : null}
      {dailyBilling ? <Col span={24} offset={offset}>{`Daily Billing Rate: $${dailyBilling.toFixed(2)}`}</Col> : null}
      {hourlyBilling ? <Col span={24} offset={offset}>{`Hourly Billing Rate: $ ${hourlyBilling.toFixed(2)}`}</Col> : null}
      {formLink || invoiceLink ? (
        <Col span={24} offset={offset}>
          {formLink}
          {invoiceLink}
        </Col>
      ) : null}
    </Row>
  );
}

/* eslint-disable react/forbid-prop-types */
HistoryEntryDetails.propTypes = {
  invoiceNumber: PropTypes.string,
  templateName: PropTypes.string,
  vendor: PropTypes.string,
  amount: PropTypes.number,
  style: PropTypes.object,
  offset: PropTypes.number,
  dailyBilling: PropTypes.number,
  hourlyBilling: PropTypes.number,
  onInvoiceClick: PropTypes.func,
  invoiceId: PropTypes.string,
  onFormClick: PropTypes.func,
  formId: PropTypes.string,
  isFormLoading: PropTypes.bool,
};

HistoryEntryDetails.defaultProps = {
  invoiceNumber: null,
  templateName: null,
  vendor: null,
  amount: 0,
  style: {},
  offset: 1,
  dailyBilling: 0,
  hourlyBilling: 0,
  onInvoiceClick: () => {},
  invoiceId: null,
  onFormClick: () => {},
  formId: null,
  isFormLoading: false,
};

export default HistoryEntryDetails;
